import Vue from "vue";
import Router from "vue-router";
import {
  Home,
  Geobeta,
  NotFound,
  FAQ,
  Blog,
  Game,
  PostDetail,
  Servers,
  ServersTermsAndConditions
} from "../components/pages";

import {
  FAQ_PAGE_NAME,
  HOME_PAGE_NAME,
  GEOBETA_PAGE_NAME,
  NOT_FOUND_PAGE_NAME,
  BLOG_PAGE_NAME,
  GAME_PAGE_NAME,
  POST_PAGE_NAME,
  SERVERS_PAGE_NAME,
  SERVERS_TAC_PAGE_NAME
} from "./names";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/minidayz1",
      name: HOME_PAGE_NAME,
      component: Home
    },
    {
      path: "/",
      name: GEOBETA_PAGE_NAME,
      component: Geobeta
    },
    {
      path: "/blog/:slug",
      name: POST_PAGE_NAME,
      component: PostDetail
    },
    {
      path: "/blog",
      name: BLOG_PAGE_NAME,
      component: Blog
    },
    {
      path: "/faq",
      name: FAQ_PAGE_NAME,
      component: FAQ
    },
    {
      path: "/game",
      name: GAME_PAGE_NAME,
      component: Game
    },
    {
      path: "/play/sp/login",
      redirect: "/"
    },
    {
      path: "/play/sp",
      redirect: "/play/sp/index.html"
    },
    {
      path: "/play/mp",
      redirect: "/play/mp/index.html"
    },
    {
      path: "/servers",
      name: SERVERS_PAGE_NAME,
      component: Servers
    },
    {
      path: "/servers/terms-and-conditions",
      name: SERVERS_TAC_PAGE_NAME,
      component: ServersTermsAndConditions
    },
    {
      path: "/404",
      alias: "*",
      name: NOT_FOUND_PAGE_NAME,
      component: NotFound,
      meta: { onlyView: true }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
